import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

import capterraSvg from './images/capterra.svg';
import g2Svg from './images/g2.svg';
import gdprSvg from './images/gdpr.svg';
import soc2Svg from './images/soc2.svg';

const items = [
  {
    spanClassName: 'bg-[#C1C9F6]',
    borderGradientClassName: 'before:bg-[linear-gradient(to_right,#B8C2E080_0%,#EAEDF6_100%)]',
    title: {
      value: '4.8',
      className: 'text-secondary-2',
    },
    description: {
      logo: capterraSvg,
      text: 'Capterra rating',
    },
  },
  {
    spanClassName: 'bg-[#F7D4D4]',
    borderGradientClassName: 'before:bg-[linear-gradient(to_right,#EEDDE7_0%,#EDEDF3_100%)]',
    title: {
      value: '4.8',
      className: 'text-new-primary-1',
    },
    description: {
      logo: g2Svg,
      text: 'G2 rating',
    },
  },
  {
    spanClassName: 'bg-[#C1F6E0]',
    borderGradientClassName: 'before:bg-[linear-gradient(to_right,#D0EEE2_0%,#EAF3EF_100%)]',
    title: {
      logo: soc2Svg,
    },
    description: {
      text: 'SOC2 Certified',
    },
  },
  {
    spanClassName: 'bg-[#C1C9F6]',
    borderGradientClassName: 'before:bg-[linear-gradient(to_right,#D6DBF5_0%,#EBEDF5_100%)]',
    title: {
      logo: gdprSvg,
    },
    description: {
      text: 'GDPR Compliant',
    },
  },
];

const Rating = ({ title }) => (
  <section className="rating safe-paddings overflow-hidden md:mt-5">
    <div className="container">
      <h2 className="text-[18px] font-medium leading-snug text-new-gray-1 text-center xl:text-[16px] lg:text-[14px]">
        {title}
      </h2>
      <ul className="grid grid-cols-12 grid-gap-x mt-12 auto-rows-[182px] xl:mt-8 xl:auto-rows-[152px] lg:mt-7 lg:grid-gap lg:auto-rows-[124px] md:auto-rows-[130px]">
        {items.map(({ spanClassName, borderGradientClassName, title, description }, index) => (
          <li
            className="col-span-3 relative rounded-2xl overflow-hidden p-px lg:col-span-6"
            key={index}
          >
            <span
              className={clsx(
                'absolute w-[400px] z-20 h-[356px] top-[-238px] left-[-238px] opacity-10 rounded-full blur-[90px]',
                spanClassName
              )}
            />
            <div
              className={clsx(
                'rounded-2xl h-full relative before:absolute before:-inset-px before:rounded-2xl',
                borderGradientClassName
              )}
            >
              <div
                className={clsx(
                  'flex items-center flex-col bg-new-gray-2 h-full relative z-10 rounded-2xl',
                  title.logo ? 'pt-7 xl:pt-5' : 'pt-4'
                )}
              >
                {title.logo ? (
                  <img
                    className="xl:h-[70px] xl:w-[70px] lg:h-14 lg:w-14 md:w-[62px] md:h-[62px]"
                    src={title.logo}
                    alt=""
                    loading="lazy"
                    width={80}
                    height={80}
                  />
                ) : (
                  <div className="font-sans2">
                    <span
                      className={clsx(
                        'text-[80px] font-thin leading-snug tracking-tight-4 xl:text-[64px] xl:tracking-tighter lg:lg:text-[48px]',
                        title.className
                      )}
                    >
                      {title.value}
                    </span>
                    <span className="font-thin tracking- tracking-[-0.07em] text-[48px] text-[#4D4D4D] leading-snug xl:text-[36px] lg:text-[26px]">
                      {' '}
                      / 5
                    </span>
                  </div>
                )}
                <div
                  className={clsx('flex gap-x-3 items-center md:gap-x-2', {
                    'mt-[19px] xl:mt-2.5': !description.logo,
                  })}
                >
                  {description.logo && (
                    <img src={description.logo} alt="" loading="lazy" width={24} height={24} />
                  )}
                  <p className="mt-0.5 text-base leading-snug text-new-gray-1 xl:mt-0 lg:-mt-1 lg:text-[14px] md:text-[12px]">
                    {description.text}
                  </p>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

Rating.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Rating;
